export const getPathForRouter = (landingUrl) => {

    return (path) => {
        return `${landingUrl}${path}`;
    }

}